import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const MainPage = () => import('components/mainPage.vue')
const Local = () => import('components/local.vue')
const Places = () => import('components/places.vue')
const Login = () => import ('components/login.vue')
const AdminPanel = () => import('components/admin-panel.vue')

export default new Router  ({
  routes: [
    {path: '/', component: MainPage},
    {path: '/lokal/:id', component: Local},
    {path: '/miejsca/:storage', component: Places},
    {path: '/login', component: Login},
    {path: '/admin-panel', component: AdminPanel, meta: {requiresAuth: true}},
    {path: '*', component: MainPage}
  ],
})



// WEBPACK FOOTER //
// ./src/router/index.js